import LookupService from "../../Services/LookupService";
import { SelectOption } from "../../shared/components/input";
import { RefiApprovalDropdownDto } from "../model/RefiApprovalDropdownDto";
import { RefiDocument } from "../model/RefiDocument";
import { RefiDocumentDto } from "../model/RefiDocumentDto";
import { RefiTodoListDto } from "../model/RefiiTodoListDto";
import { getListOfVestingDropdown, fetchRefiTodoList, getRefiDocumentFields, getRefiDocument, rejectRefiDocument, approveRefiDocument } from "../services/DocuMateAPI";
import * as constant from '../shared/util/docuMateConstant';
import validator from 'validator';

export const requestTypeList: SelectOption[] = [{
    label : '(R) Refinance',
    value : 'R'
},
{
    label : '(L) Lender Change Request',
    value : 'L'
},
{
    label : '(E) Evidence of Insurance',
    value : 'E'
}];

export const carrierList: SelectOption[] = [
    {
    label : 'ASI',
    value : 'ASI',
    },
    {
    label : 'Universal',
    value : 'Universal North America Ins Co'
    },
    {
    label : 'American Integrity',
    value : 'American Integrity Insurance Co'
    }
];

export const impoundsList: SelectOption[] = [
{
    label : 'Yes',
    value : '1'
},
{
    label : 'No',
    value : '0'
}];

export const loanPositionList: SelectOption[] = [{
    label : '1',
    value : '1'
},
{
    label : '2',
    value : '2'
},
{
    label : '3',
    value : '3'
}];

export const getRefiTodoList = async() : Promise<RefiTodoListDto[]> =>  {
    let refiList = await fetchRefiTodoList();
    let refiTodoList = refiList ? refiList.map(item => {
        return {
            refiRequestId: item.refiRequestId,
            fileName: item.fileName.replace(/\.[^/.]+$/, ""), // Remove the extension if it exists
            docDesc: item.docDesc,
            dateAvailable: item.dateAvailable,
            dateInitiated: item.dateInitiated,
            isLocked: false,
            status: item.status,
            updatedBy: item.updatedBy,
            updateDateTime: item.updateDateTime
        }
    }) : [];
    return refiTodoList;
}

export const handleToggleLockDocument = async(id: string) => {
    // make api call to toggle lock on the document
    // update flag to db
    return;
}

// export const approveDocument = async(id: string) => {
//     // make api call to approve the document
//     const refiDocument = todoList.find((doc) => doc.refiRequestId === id);
//     if (refiDocument) {
//         refiDocument.status = 'Approved';
//     }
//     return nextDocument;
// }

export const getRequestTypeDropdownOptions = () => {
    return requestTypeList;
}

export const getCarrierDropdownOptions = () => {
    return carrierList;
}

export const getImpoundsDropdownOptions = () => {
    return impoundsList;
}

export const getLoanPositionDropdownOptions = () => {
    return loanPositionList;
}

export const getStatesList = async () => {
    let stateList = await LookupService.fetchState();
    let stateOptions = stateList ? stateList.map(item => {
        return {
            label: item.lookupValue,
            value: item.lookupCode,
            isInactive: false
        }
    }) : [];
    return stateOptions;
}

class DocuMateRefiService {
    public validateRefiDocument = (refiDocument: RefiDocumentDto) : any => {
        let validationErrors = {};
        // if(!refiDocument) {
        //     validationErrors['rootObject'] = {isValid: false, warningText: constant.DOCUMENT_NOT_FOUND};
        // }
        if(!refiDocument.requestType || refiDocument.requestType?.length === 0) {
            validationErrors['requestType'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        // if(!refiDocument.vesting || refiDocument.vesting?.length === 0) {
        //     validationErrors['vesting'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        // }
        if(!refiDocument.policyNbr || refiDocument.policyNbr?.length === 0) {
            validationErrors['policyNbr'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.carrierName || refiDocument.carrierName?.length === 0) {
            validationErrors['carrierName'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        // if((!refiDocument.writingCompanyName || refiDocument.writingCompanyName?.length === 0)) {
        //     if((!refiDocument.custFirstName || refiDocument.custFirstName?.length === 0))
        //     {
        //         validationErrors['custFirstName'] = {isValid: false};
        //         validationErrors['writingCompanyName'] = {isValid: false, warningText: constant.CUSTOMER_NAME_MANDATORY_FIELDS_ERROR};
        //     }
        //     else if (refiDocument.custFirstName?.trim().length > 0 && refiDocument.custFirstName?.trim().length < 2) {
        //         validationErrors['custFirstName'] = {isValid : false, warningText : constant.CUSTOMER_NAME_MIN_LENGTH };
        //     }
        //     if ((!refiDocument.custLastName || refiDocument.custLastName?.length === 0)) {
        //         validationErrors['custLastName'] = {isValid: false};
        //         validationErrors['writingCompanyName'] = {isValid: false, warningText: constant.CUSTOMER_NAME_MANDATORY_FIELDS_ERROR};
        //     }
        //     else if (refiDocument.custLastName?.trim().length > 0 && refiDocument.custLastName?.trim().length < 2) {
        //         validationErrors['custLastName'] = {isValid : false, warningText : constant.CUSTOMER_NAME_MIN_LENGTH };
        //     }
        // }
        if((!refiDocument.custFirstName || refiDocument.custFirstName?.length === 0)) {
            validationErrors['custFirstName'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        else if (refiDocument.custFirstName?.trim().length > 0 && refiDocument.custFirstName?.trim().length < 2) {
            validationErrors['custFirstName'] = {isValid : false, warningText : constant.CUSTOMER_NAME_MIN_LENGTH };
        }
        if((!refiDocument.isBusiness && (!refiDocument.custLastName || refiDocument.custLastName?.length === 0))) {
            validationErrors['custLastName'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        else if (!refiDocument.isBusiness && (refiDocument.custLastName?.trim().length > 0 && refiDocument.custLastName?.trim().length < 2)) {
            validationErrors['custLastName'] = {isValid : false, warningText : constant.CUSTOMER_NAME_MIN_LENGTH };
        }
        if (!refiDocument.vestingAddressLine1 || refiDocument.vestingAddressLine1?.length == 0) {
            validationErrors['vestingAddressLine1'] = {isValid : false, warningText : constant.MANDATORY_FIELDS };
        }
        if (!refiDocument.vestingAddrCity || refiDocument.vestingAddrCity?.length == 0) {
            validationErrors['vestingAddrCity'] = {isValid : false, warningText : constant.MANDATORY_FIELDS };
        }
        if(!refiDocument.vestingAddrState || refiDocument.vestingAddrState?.length === 0) {
            validationErrors['vestingAddrState'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if (!refiDocument.vestingAddrZipCode || refiDocument.vestingAddrZipCode?.length == 0) {
            validationErrors['vestingAddrZipCode'] = {isValid : false, warningText : constant.MANDATORY_FIELDS };
        }
        if (refiDocument.vestingAddressLine1?.trim().length > 0 && refiDocument.vestingAddressLine1?.trim().length < 2) {
            validationErrors['vestingAddressLine1'] = {isValid : false, warningText : constant.CUSTOMER_ADDRESS1_MIN_LENGTH };
        }
        if (refiDocument.vestingAddrCity?.trim().length > 0 && refiDocument.vestingAddrCity?.trim().length < 2) {
            validationErrors['vestingAddrCity'] = {isValid : false, warningText : constant.CUSTOMER_CITY_MIN_LENGTH };
        }
        if (refiDocument.vestingAddrZipCode?.trim().length > 0) {
            if (refiDocument.vestingAddrZipCode.trim().length != 5 && refiDocument.vestingAddrZipCode.trim().length != 10) {
            validationErrors['vestingAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
            let zip = refiDocument.vestingAddrZipCode.replace('-', '');
            if (!/^\d+$/.test(zip)) {
            validationErrors['vestingAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
        }
        if(!refiDocument.loanNumber || refiDocument.loanNumber?.length === 0) {
            validationErrors['loanNumber'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.loanPosition || refiDocument.loanPosition?.length === 0) {
            validationErrors['loanPosition'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.impound || refiDocument.impound?.length === 0) {
            validationErrors['impound'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.mortgageeName || refiDocument.mortgageeName?.length === 0) {
            validationErrors['mortgageeName'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        // if(!refiDocument.mortgageeClause || refiDocument.mortgageeClause?.length === 0) {
        //     validationErrors['mortgageeClause'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        // }
        if(!refiDocument.mortgageeNameAddressLine1 || refiDocument.mortgageeNameAddressLine1?.length === 0) {
            validationErrors['mortgageeNameAddressLine1'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.mortgageeNameAddrCity || refiDocument.mortgageeNameAddrCity?.length === 0) {
            validationErrors['mortgageeNameAddrCity'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.mortgageeNameAddrState || refiDocument.mortgageeNameAddrState?.length === 0) {
            validationErrors['mortgageeNameAddrState'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if(!refiDocument.mortgageeNameAddrZipCode || refiDocument.mortgageeNameAddrZipCode?.length === 0) {
            validationErrors['mortgageeNameAddrZipCode'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if (refiDocument.mortgageeNameAddressLine1?.trim().length > 0 && refiDocument.mortgageeNameAddressLine1?.trim().length < 2) {
            validationErrors['mortgageeNameAddressLine1'] = {isValid : false, warningText : constant.CUSTOMER_ADDRESS1_MIN_LENGTH };
        }
        if (refiDocument.mortgageeNameAddrCity?.trim().length > 0 && refiDocument.mortgageeNameAddrCity?.trim().length < 2) {
            validationErrors['mortgageeNameAddrCity'] = {isValid : false, warningText : constant.CUSTOMER_CITY_MIN_LENGTH };
        }
        if (refiDocument.mortgageeNameAddrZipCode?.trim().length > 0 && (refiDocument.mortgageeNameAddrZipCode?.trim().length < 2 || refiDocument.mortgageeNameAddrZipCode?.trim().length > 10)) {
            validationErrors['mortgageeNameAddrZipCode'] = {isValid : false, warningText : constant.ZIPCODE_INVALID_MESSAGE };
        }
        if (refiDocument.mortgageeNameAddrZipCode?.trim().length > 0) {
            if (refiDocument.mortgageeNameAddrZipCode.trim().length != 5 && refiDocument.mortgageeNameAddrZipCode.trim().length != 10) {
            validationErrors['mortgageeNameAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
            let zip = refiDocument.mortgageeNameAddrZipCode.replace('-', '');
            if (!/^\d+$/.test(zip)) {
            validationErrors['mortgageeNameAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
        }
        if(!refiDocument.requestorName || refiDocument.requestorName?.length === 0) {
            validationErrors['requestorName'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        else if (refiDocument.requestorName.trim().length > 0 && refiDocument.requestorName.trim().length < 2) {
            validationErrors['requestorName'] = {isValid : false, warningText : constant.CUSTOMER_NAME_MIN_LENGTH };
        }
        if(!refiDocument.requestorEmail || refiDocument.requestorEmail?.length === 0) {
            validationErrors['requestorEmail'] = {isValid: false, warningText: constant.MANDATORY_FIELDS};
        }
        if (refiDocument.requestorEmail?.trim().length > 0 && !validator.isEmail(refiDocument.requestorEmail?.trim())) {
            validationErrors['requestorEmail'] = {isValid : false, warningText : constant.REQUESTOR_INVALID_EMAIL };
        }
    return validationErrors;

    }

    public validateRejectRefiDocument = (refiDocument: RefiDocumentDto): any => {
        let validationErrors = {};
        if ((!refiDocument.custFirstName || refiDocument.custFirstName?.length === 0)) {
            validationErrors['custFirstName'] = { isValid: false, warningText: constant.MANDATORY_FIELDS };
        }
        else if (refiDocument.custFirstName?.trim().length > 0 && refiDocument.custFirstName?.trim().length < 2) {
            validationErrors['custFirstName'] = { isValid: false, warningText: constant.CUSTOMER_NAME_MIN_LENGTH };
        }

        if ((!refiDocument.isBusiness && (!refiDocument.custLastName || refiDocument.custLastName?.length === 0))) {
            validationErrors['custLastName'] = { isValid: false, warningText: constant.MANDATORY_FIELDS };
        }
        else if (!refiDocument.isBusiness && (refiDocument.custLastName?.trim().length > 0 && refiDocument.custLastName?.trim().length < 2)) {
            validationErrors['custLastName'] = { isValid: false, warningText: constant.CUSTOMER_NAME_MIN_LENGTH };
        }

        if (refiDocument.vestingAddrZipCode?.trim().length > 0) {
            if (refiDocument.vestingAddrZipCode.trim().length != 5 && refiDocument.vestingAddrZipCode.trim().length != 10) {
                validationErrors['vestingAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
            let zip = refiDocument.vestingAddrZipCode.replace('-', '');
            if (!/^\d+$/.test(zip)) {
                validationErrors['vestingAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
        }        

        if (refiDocument.mortgageeNameAddrZipCode?.trim().length > 0) {
            if (refiDocument.mortgageeNameAddrZipCode.trim().length != 5 && refiDocument.mortgageeNameAddrZipCode.trim().length != 10) {
                validationErrors['mortgageeNameAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
            let zip = refiDocument.mortgageeNameAddrZipCode.replace('-', '');
            if (!/^\d+$/.test(zip)) {
                validationErrors['mortgageeNameAddrZipCode'] = { isValid: false, warningText: constant.ZIPCODE_INVALID_MESSAGE };
            }
        }

        if (refiDocument.requestorEmail?.trim().length > 0 && !validator.isEmail(refiDocument.requestorEmail?.trim())) {
            validationErrors['requestorEmail'] = { isValid: false, warningText: constant.REQUESTOR_INVALID_EMAIL };
        }
        return validationErrors;

    }

    getVestingList = async (): Promise<SelectOption[]> => {
            var vestingList = await getListOfVestingDropdown();
            const vestingDropdownOptions = vestingList.map((item: RefiApprovalDropdownDto) => (
                {
                    label: item.lookupValue,
                    value: item.lookupValue,
                }));
    
            return vestingDropdownOptions;
        }

    getStatesList = async () => {
        let stateList = await LookupService.fetchUSStates();
        let stateOptions = stateList ? stateList.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
        return stateOptions;
    }

    fetchRefiDocumentFields = async (id: string) : Promise<RefiDocumentDto> => {
        // make api call to get current document
        let refiDocument = await getRefiDocumentFields(id);
        let refiDocumentDto: RefiDocumentDto = refiDocument ? {
            ...refiDocument,
            refiRequestId: refiDocument.id,
            requestorName: (refiDocument.requestorFirstName || refiDocument.requestorLastName) ? `${refiDocument.requestorFirstName || ''} ${refiDocument.requestorLastName || ''}`.trim() : '',
            impound: refiDocument.impound ? '1' : '0',
            isBusiness: false
        } : null;
        if (refiDocumentDto.vestingAddrZipCode) {
            const zip = refiDocumentDto.vestingAddrZipCode.replace(/[^0-9]/g, "");
            if (zip.length === 9) {
                refiDocumentDto.vestingAddrZipCode = zip.slice(0, 5) + '-' + zip.slice(5, 9);
            } else if (zip.length === 5) {
                refiDocumentDto.vestingAddrZipCode = zip;
            } else {
                refiDocumentDto.vestingAddrZipCode = "";
            }
        }
        if(refiDocumentDto.mortgageeNameAddrZipCode) {
            const zip = refiDocumentDto.mortgageeNameAddrZipCode.replace(/[^0-9]/g, "");
            if (zip.length === 9) {
                refiDocumentDto.mortgageeNameAddrZipCode = zip.slice(0, 5) + '-' + zip.slice(5, 9);
            } else if (zip.length === 5) {
                refiDocumentDto.mortgageeNameAddrZipCode = zip;
            } else {
                refiDocumentDto.mortgageeNameAddrZipCode = "";
            }
        }
        return refiDocumentDto;
    }

    fetchRefiDocument = async (id: string) => {
        // make api call to get current document
        let refiDocument = await getRefiDocument(id);
        return refiDocument;
    }

    rejectRefiDocument = async (refiDocument: RefiDocumentDto) => {
        let rejectDocumentRequest: RefiDocument = {
            ...refiDocument,
            id: refiDocument.refiRequestId,
            impound: refiDocument.impound === '1' ? true : false,
            requestorFirstName: refiDocument.requestorName ? refiDocument.requestorName.split(' ')[0] : "",
            requestorLastName: (refiDocument.requestorName && refiDocument.requestorName.split(' ').length > 1) ? refiDocument.requestorName.split(' ')[1] : ""
        };
        let res = await rejectRefiDocument(rejectDocumentRequest);
        return res;
    }

    approveRefiDocument = async (refiDocument: RefiDocumentDto) => {
        let approveDocumentRequest: RefiDocument = {
            ...refiDocument,
            id: refiDocument.refiRequestId,
            impound: refiDocument.impound === '1' ? true : false,
            requestorFirstName: refiDocument.requestorName ? refiDocument.requestorName.split(' ')[0] : "",
            requestorLastName: refiDocument.requestorName ? refiDocument.requestorName.split(' ')[1] : ""
        };
        console.log('approveDocRequest', approveDocumentRequest);
        let res = await approveRefiDocument(approveDocumentRequest);
        return res;
    }
}

export default DocuMateRefiService;